module.exports = __webpack_public_path__ + "img/logoEscola.ceee7523.png";